'use client';

import type { Listing } from '@repo/api';
import { Accordion } from '@/components/ui/Accordion';
import { Divider, SectionContainer, SectionHeader } from '@/components/ui';
import { cn } from '@/lib/cn';

interface UnitFaqsProps {
  listing: Listing;
}

export function UnitFaqs({ listing }: UnitFaqsProps) {
  const faqs = listing.faqs;

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      <SectionHeader title="FAQ" />

      <div className="w-full md:px-2">
        <div className="flex flex-col gap-1 items-start w-full">
          {faqs.map((faq, index) => (
            <div key={index} className="w-full">
              <div className="flex flex-col items-start w-full">
                <Accordion
                  header={faq.question}
                  headerClassName={cn('px-2')}
                  contentClassName={cn('px-2')}
                  closeOnOutsideClick={true}
                >
                  <p className="text-body-2 text-primary">{faq.answer}</p>
                </Accordion>
              </div>

              {index < faqs.length - 1 && <Divider variant="secondary" className="my-1" />}
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  );
}
